import {
  CHANNEL_APP,
  CHANNEL_SMS,
  CHANNEL_EMAIL,
  CHANNEL_CALL,
  TWITTER_VALUE,
  FACEBOOK_VALUE,
  INSTAGRAM_VALUE,
  LINKEDIN_VALUE,
  LINE_VALUE,
} from 'app/constants/channel'
import { TYPE_GENERAL, TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'

export const NON_EXPIRING = 'noneExpiring'
export const EXPIRED = 'expired'
export const EXPIRING = 'expiring'

export const SENT_FILTER = 'sentFilter'
export const UNSENT_FILTER = 'unsentFilter'
export const DRAFT_FILTER = 'draftFilter'
export const SCHEDULE_FILTER = 'schedule'

export const SENT = 'SENT'
export const UNSENT = 'UNSENT'
export const DRAFT = 'DRAFT'
export const SCHEDULED = 'SCHEDULED'

export const CREATED_BY_ME = 'createdByMe'

export const CHECKED = 1
export const MAX_LENGTH_CENCEL_REASON = 100

export const SORT_CREATED_AT = 'createdAt'
export const SORT_STATUSES = 'statuses'

export const RECEIVED = 'received'
export const NOT_RECEIVED = 'notReceived'

export const READ = 'read'
export const FEED_READ = 'feedRead'
export const DID_NOT_READ = 'didntRead'

export const LIKED = 'liked'
export const REPORTS = 'reports'
export const DID_LIKE = 'didntLike'

export const SEXUAL_CONTENT = '1'
export const VIOLENT_CONTENT = '2'
export const HATEFUL_CONTENT = '3'
export const HAMEFUL_CONTENT = '4'
export const SPAM_CONTENT = '5'

export const PARTIALY_LISTENED = 'listened'
export const FULLY_LISTENED = 'fullListened'

export const TTS = 'tts'
export const DELIVER = 'deliver'
export const REACTION = 'reaction'

export const PARAM_GOING_ACTION = '1'
export const PARAM_MAYBE_ACTION = '2'
export const PARAM_NOT_GOING_ACTION = '3'

export const TABLE_VIEW = 0
export const CARD_VIEW = 1

export const MSG_DETAIL_TAB = 0
export const METRICS_TAB = 1

export const DELETED_MSG = 'deleted'
export const UPDATED_MSG = 'updated'

export const UNSENT_EVENT = 'unsent'
export const CANCEL_EVENT = 'cancel'

export const POLL_OPEN = 'opened'
export const POLL_END = 'ended'
export const POLL_TPYE_SINGLE = 'single'
export const POLL_TPYE_MULTI = 'multiple'

export const IN_ACTIVE = 0
export const ACTIVE = 1

export const COMMENTS_ENTITY_TYPE = 2
export const COMMENTS_CREATOR_TYPE = 2

export const filterType = [
  {
    id: TYPE_GENERAL,
    name: 'general',
    label: 'notification.type.general',
    value: TYPE_GENERAL,
  },
  {
    id: TYPE_EVENT,
    name: 'event',
    label: 'notification.type.event',
    value: TYPE_EVENT,
  },
  {
    id: TYPE_POLL,
    name: 'poll',
    label: 'notification.type.poll',
    value: TYPE_POLL,
  },
]
export const filterExpiration = [
  {
    id: 1,
    name: NON_EXPIRING,
    label: 'text.non.expired',
    value: CHECKED,
  },
  {
    id: 2,
    name: EXPIRED,
    label: 'text.expired',
    value: CHECKED,
  },
  {
    id: 3,
    name: EXPIRING,
    label: 'text.expiring',
    // //    checked: false
    value: CHECKED,
  },
]
export const filterStatus = [
  {
    id: 1,
    name: SENT_FILTER,
    label: 'text.sent',
    value: CHECKED,
    //    checked: false
  },
  {
    id: 2,
    name: UNSENT_FILTER,
    label: 'text.unsent',
    value: CHECKED,
    //    checked: false
  },

  {
    id: 3,
    name: DRAFT_FILTER,
    label: 'text.draft',
    value: CHECKED,
    //    checked: false
  },
  {
    id: 4,
    name: SCHEDULE_FILTER,
    label: 'text.scheduled',
    value: CHECKED,
    //    checked: false
  },
]
export const filterCreatBy = [
  {
    id: 1,
    name: CREATED_BY_ME,
    label: 'text.me',
    value: CHECKED,
    //    checked: false
  },
]

export const channelsList = {
  [CHANNEL_APP]: {
    id: CHANNEL_APP,
    name: 'subscriber.filter.notification.method.app',
  },
  [CHANNEL_SMS]: {
    id: CHANNEL_SMS,
    name: 'subscriber.filter.notification.method.sms',
  },
  [CHANNEL_EMAIL]: {
    id: CHANNEL_EMAIL,
    name: 'subscriber.filter.notification.method.email',
  },
  [CHANNEL_CALL]: {
    id: CHANNEL_CALL,
    name: 'message.credit.alert.dialog.automateCall',
  },
  [TWITTER_VALUE]: {
    id: TWITTER_VALUE,
    name: 'socialMediaIntegrations.provider.twitter.title',
  },
  [FACEBOOK_VALUE]: {
    id: FACEBOOK_VALUE,
    name: 'socialMediaIntegrations.provider.facebook.title',
  },
  [INSTAGRAM_VALUE]: {
    id: INSTAGRAM_VALUE,
    name: 'socialMediaIntegrations.provider.instagram.title',
  },
  [LINKEDIN_VALUE]: {
    id: LINKEDIN_VALUE,
    name: 'socialMediaIntegrations.provider.linkedin.title',
  },
  [LINE_VALUE]: {
    id: LINE_VALUE,
    name: 'crm.form.lineProfile',
  },
}

export const timelineFilter = {
  filterExpiration,
  filterStatus,
  filterCreatBy,
}
